import Button from 'tailwind-components/Button/Button';
import Input from 'tailwind-components/Input/Input';
import React, { useRef } from 'react';
import propTypes from 'prop-types';
import style from './inputWithCopyButton.module.scss';
import { Copy } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { showAlert } from 'state/actions/site';

function InputWithCopyButton({
  className,
  noSpacing,
  fixedWidth,
  ...inputProps
}) {
  const input = useRef(null);
  const dispatch = useDispatch();

  const copyText = () => {
    navigator.clipboard.writeText(input.current.value);
    dispatch(showAlert({ message: 'Copied to clipboard!', code: 'success' }));
  };

  return (
    <span className={`${style.inputWithCopyButton} ${className}`}>
      <Input
        ref={input}
        {...inputProps}
        noSpacing={noSpacing}
        fixedWidth={fixedWidth}
      />
      <div className={style.button}>
        <Button
          size='xsmall'
          variant='secondary'
          outlined
          text={'Copy'}
          icon={<Copy className='size-inherit' strokeWidth={2} />}
          onClick={copyText}
          isDisabled={!input?.current?.value}
        />
      </div>
    </span>
  );
}

InputWithCopyButton.propTypes = {
  className: propTypes.string,
  noSpacing: propTypes.bool,
  fixedWidth: propTypes.bool
};

export default InputWithCopyButton;
